import makeStyles from '@material-ui/core/styles/makeStyles';
import {ReactComponent as Logo} from './icon/logo.svg';
import {ReactComponent as Arrow} from './icon/arrow.svg';

export const useStyles = makeStyles(() => ({
    root: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        width: 'calc(100% - 30px)', 
        margin: '0 auto 0', 
        padding: '20px 15px 0px'
    },
    wrapLeft: {
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-betweent'
    },
    wrapRight: {
        padding: '13px 15px 14px 22px', 
        width: 120, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        background: 'rgba(14, 20, 70, 0.71)', 
        backgroundBlendMode: 'soft-light, normal', 
        backdropFilter: 'blur(48px)', 
        borderRadius: 17,
        cursor: 'pointer'
    },
    wrapTitle: {
        display: 'flex', 
        flexDirection: 'column', 
        paddingLeft: 28
    },
    title: {
        color: '#525F98',
        fontFamily: 'Circe, sans-serif', 
        fontWeight: 'normal'
    },
    btnText: {
        fontFamily: 'Circe, sans-serif', 
        fontWeight: 700, 
        fontSize: 16, 
        color: '#fff'
    },
    arrow: {
        width: 36, 
        height: 36, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#DCAF4C', 
        borderRadius: 14
    }
}))

export {
    Logo,
    Arrow
}